import type { Router } from 'vue-router' // 确保导入 Router 类型
import { formatter } from '@/utils'
import dayjs from 'dayjs'

// 类型定义
export interface Option {
  label: string
  value: string
}

export interface Column {
  title: string
  key: string
  render?: (row: any & { $router?: Router }) => VNode
}

// 时间筛选配置
// export const options: Option[] = [
//   {
//     label: 'Tudo Agente Ganhos',
//     value: 'All',
//   },
//   {
//     label: 'Nível 1 Agente Ganhos',
//     value: 'Level1',
//   },
//   {
//     label: 'Nível 2 Agente Ganhos',
//     value: 'Level2',
//   },
//   {
//     label: 'Nível 3 Agente Ganhos',
//     value: 'Level3',
//   },
// ]
export function getOptions(t: (key: string) => string) {
  return [
    {
      label: t('Activities.Agentcenter.Income.AllAgentEarnings'),
      value: 'All',
    },
    {
      label: t('Activities.Agentcenter.Income.Level1AgentEarnings'),
      value: 'Level1',
    },
    {
      label: t('Activities.Agentcenter.Income.Level2AgentEarnings'),
      value: 'Level2',
    },
    {
      label: t('Activities.Agentcenter.Income.Level3AgentEarnings'),
      value: 'Level3',
    },
  ]
}
// 我的收益
export function getColumnsSelf(t: (key: string) => string): Column[] {
  return [
    {
      title: t('Activities.Agentcenter.Income.Date'),
      key: 'statisticalDate',
      render: (row: any) => (
        <div class="text-13 flex-center size-full">
          {dayjs(row.statisticalDate).format('DD/MM/YYYY')}
        </div>
      ),
    },
    {
      title: t('Activities.Agentcenter.Income.MyEarnings'),
      key: 'myIncome',
      render: (row: any) => (
        <div class="text-13 flex-center size-full">
          {formatter().format(row.myIncome)}
        </div>
      ),
    },
    {
      title: t('Activities.Agentcenter.Income.SubordinateDeposits'),
      key: 'subDeposit',
      render: (row: any) => (
        <div class="text-13 flex-center size-full">
          {formatter().format(row.subDeposit)}
        </div>
      ),
    },
    {
      title: t('Activities.Agentcenter.Income.SubordinateWithdrawals'),
      key: 'subWithdrawal',
      render: (row: any) => (
        <div class="text-13 flex-center size-full">
          {formatter().format(row.subWithdrawal)}
        </div>
      ),
    },
    {
      title: t('Activities.Agentcenter.Income.SubordinateBets'),
      key: 'subBet',
      render: (row: any) => (
        <div class="text-13 flex-center size-full">
          {formatter().format(row.subBet)}
        </div>
      ),
    },
    {
      title: t('Activities.Agentcenter.Income.SubordinateProfit'),
      key: 'subWinLoss',
      render: (row: any) => (
        <div
          class={`text-13 flex-center size-full ${
            row.subWinLoss > 0
              ? 'text-[#64F765]'
              : row.subWinLoss < 0
                ? 'text-[#FF0000]'
                : ''
          }`}
        >
          {row.subWinLoss > 0 ? '+' : ''}
          {formatter().format(row.subWinLoss)}
        </div>
      ),
    },
  ]
}

export function getColumnsTeam(t: (key: string) => string): Column[] {
  return [
    {
      title: t('Activities.Agentcenter.Income.AgentId'),
      key: 'userid',
      render: (row: any & { $router?: Router }) => (
        <div
          onClick={() =>
            row.$router?.push(`/agentdetail?agentUserid=${row.userid}`)
          }
          style="cursor: pointer;"
        >
          {row.userid}
        </div>
      ),
    },
    {
      title: t('Activities.Agentcenter.Income.AgentLevel'),
      key: 'agentLevel',
      render: (row: any) => <>{`${row.agentLevel} Nível`}</>,
    },
    {
      title: t('Activities.Agentcenter.Income.ParentId'),
      key: 'parentId',
      render: (row: any & { $router?: Router }) => (
        <div
          onClick={() =>
            row.$router?.push(`/agentdetail?agentUserid=${row.parentId}`)
          }
          style="cursor: pointer;"
        >
          {row.parentId}
        </div>
      ),
    },
    {
      title: t('Activities.Agentcenter.Income.ContributionAmount'),
      key: 'contributionAmount',
      render: (row: any) => <>{formatter().format(row.contributionAmount)}</>,
    }
  ]
}
// 团队收益
// export const columnsTeam: Column[] = [
  // {
  //   title: 'ID do usuário',
  //   key: 'userid',
  //   render: (row: any & { $router?: Router }) => (
  //     <div
  //       onClick={() =>
  //         row.$router?.push(`/agentdetail?agentUserid=${row.userid}`)
  //       }
  //       style="cursor: pointer;"
  //     >
  //       {row.userid}
  //     </div>
  //   ),
  // },
  // {
  //   title: 'Nível Agente',
  //   key: 'agentLevel',
  //   render: (row: any) => <>{`${row.agentLevel} Nível`}</>,
  // },
  // {
  //   title: 'ID do superior',
  //   key: 'parentId',
  //   render: (row: any & { $router?: Router }) => (
  //     <div
  //       onClick={() =>
  //         row.$router?.push(`/agentdetail?agentUserid=${row.parentId}`)
  //       }
  //       style="cursor: pointer;"
  //     >
  //       {row.parentId}
  //     </div>
  //   ),
  // },
  // {
  //   title: 'Fornecer renda',
  //   key: 'contributionAmount',
  //   render: (row: any) => <>{formatter().format(row.contributionAmount)}</>,
  // },
// ]
